import { Component, OnInit } from '@angular/core';


import { ExpensesService } from '../../services/expenses.service';
import { DistributorService } from '../../../distributors/services/distributor.service';
import { ShopService } from '../../../configuration/services/shop.service';

import * as _ from 'lodash/lodash';
import * as moment from 'moment/moment';
declare let alasql;

@Component({
  selector: 'app-list-expenses',
  templateUrl: './list-expenses.component.html',
  styleUrls: ['./list-expenses.component.css'],
  providers:[ExpensesService,DistributorService,ShopService]
})
export class ListExpensesComponent implements OnInit {
    p: number = 1;
    totalItems: number = 0;
    expenses: any = [];  
    filteredDistributors: any = [];
    selectedDistributor: string = "";
    distributors: any = [];
    shops: any = [];
    filters:any = {
    };
    fromDate:any;
    untilDate:any;
    exportParams:any ={};
    config: any = {'sourceField': ['name']};
  
    constructor(private expensesService: ExpensesService,private distributorService:DistributorService, private shopService:ShopService) { }
  
    ngOnInit() {
        this.getExpenses();
        this.getDistributors();
        this.getShops();
    }

    getShops(){
      return new Promise((resolve, reject) => {
          this.shopService.query({})
          .subscribe((shops) => {
              this.shops = shops;
              this.shops.unshift({name:"Todas", id:""})
              resolve();
          });
      });
    }

    getDistributor(value){
      if (value.id){
        this.filters.distributor = value.id;
      }else{
        delete this.filters.distributor;
      }
    }

    filterDistributors(value){
      this.selectedDistributor = value;
      this.filteredDistributors = _.filter(this.distributors, function(o) { return o.name.toLowerCase().includes(value.toLowerCase()); });
      if (value == ""){
        delete this.filters.distributor;
      }
    }

    getDistributors(){
      this.distributorService.query({})
      .subscribe((distributors) => {
          this.distributors = distributors;
          this.filteredDistributors = distributors;
      }); 
    }
  
    getExpenses(){
      var params = {
        where: _.cloneDeep(this.filters),
        sort: 'id DESC',
        skip: (this.p-1)*10,
        limit: 30
      };
      if (this.fromDate && moment(this.fromDate, "DD-MM-YYYY").format("YYYY-MM-DD") != 'Invalid date'){
        params.where.invoice_date = params.where.invoice_date? params.where.invoice_date:{};
        params.where.invoice_date[">="] = moment(this.fromDate, "DD-MM-YYYY").format("YYYY-MM-DD");
      }
      if (this.untilDate && moment(this.untilDate, "DD-MM-YYYY").format("YYYY-MM-DD") != 'Invalid date'){
        params.where.invoice_date = params.where.invoice_date? params.where.invoice_date:{};
        params.where.invoice_date["<="] = moment(this.untilDate, "DD-MM-YYYY").format("YYYY-MM-DD");
      }
      this.exportParams = params;
      this.expensesService.query(params)
                 .subscribe((expenses) => {
                    this.expensesService.count({})
                    .subscribe((count) => {
                      this.totalItems = count.count;
                    });
                    this.expenses = expenses;
                  });
    }

    exportExpensesToExcel(){
      var options = {   
          fieldSeparator: ';',
          quoteStrings: '"',
          decimalseparator: '.',
          showLabels: false,
          showTitle: false,
          useBom: false,   
          bookType:'xlsx' ,  
          cellStyles:true,
      };             
      let report = [
            {
                field1:"Número",
                field2:"Fecha",
                field3:"Nombre Distribuidor",
                field4:"CIF Distribuidor",
                field5:"Concepto",
                field6:"Importe",
                field7:"Método de pago",
                field8:"Tienda"
                
            }
        ]
        delete this.exportParams.skip;
        delete this.exportParams.limit;
        this.expensesService.query(this.exportParams)
                .subscribe((expenses) => {
                expenses.forEach(expense =>{
                    var row = {
                        field1:expense.invoice_number,
                        field2:expense.invoice_date?moment(expense.invoice_date).format("DD-MM-YYYY"):"",
                        field3:expense.distributor?expense.distributor.name:"",
                        field4:expense.distributor?expense.distributor.cif:"",
                        field5:expense.concept,
                        field6:expense.amount,
                        field7:expense.method_of_payment,
                        field8:expense.shop?expense.shop.name:""
                    }
                    report.push(row);
                  
                });
                
                var mystyle = {   
                    headers:true,       
                    columns:    
                        [{columnid:'field1',width:50,title: ''},   
                        {columnid:'field2',width:100,title: ''},
                        {columnid:'field3',width:100,title: 'LISTADO DE GASTOS'},
                        {columnid:'field4',width:100,title: ''},
                        {columnid:'field5',width:200,title: ''},
                        {columnid:'field6',width:100,title: ''},
                        {columnid:'field7',width:100,title: ''},
                        {columnid:'field8',width:100,title: ''}
                        
                        ],
                    /*header*/
                  
                    column: {  
                        style:{
                            Alignment:{
                                Horizontal:"Center",
                                Vertical:"Center",  
                                WrapText:1
                                
                            },
                            Font:{
                                Bold:"1",
                                Color:"#000000",
                                Size:10
                            },
                            
                            Interior:{
                                Color:"#7CEECE",
                                Pattern:"Solid"
                            }
                        }},
                  cells: {    
                        0:{
                            0:{style:{
                                Interior:{ 
                                    Color:"#95a5a6",
                                    Pattern:"Solid",
                                        },
                                Alignment:{
                                  Horizontal:"Center",
                                  Vertical:"Center",
                                  WrapText: 1,
                                    },  
                                Font:{
                                    Size:10,
                                    Bold:"1",
                                    Color:"#000000",
                                },                        
                                }  
                            },
                            1:{style:{
                                Interior:{ 
                                    Color:"#95a5a6",
                                    Pattern:"Solid"
                                        },
                                Alignment:{
                                    Horizontal: 'Center', 
                                    Vertical: 'Center',
                                    WrapText: 1, 
                            },  
                                Font:{
                                        Size:10,
                                        Bold:"1",
                                        Color:"#000000",
                                },            
                                    }
                            },
                            2:{style:{
                                Interior:{ 
                                    Color:"#95a5a6",
                                    Pattern:"Solid"
                                        },
                                Alignment:{
                                    Horizontal: 'Center', 
                                    Vertical: 'Center',
                                    WrapText: 1, 
                                        }, 
                                Font:{
                                    Size:10,
                                    Bold:"1",
                                    Color:"#000000",
                            }                
                                    }
                                },
                            3:{style:{
                                Interior:{ 
                                    Color:"#95a5a6",
                                    Pattern:"Solid"
                                        },
                                Alignment:{
                                    Horizontal: 'Center', 
                                    Vertical: 'Center',
                                    WrapText: 1,
                                        },
                                Font:{
                                    Size:10,
                                    Bold:"1",
                                    Color:"#000000",
                            },            
                                      
                                    }
                                },
                            4:{style:{
                                Interior:{ 
                                    Color:"#95a5a6",
                                    Pattern:"Solid"
                                        },
                                Alignment:{
                                    Horizontal: 'Center', 
                                    Vertical: 'Center',
                                    WrapText: 1, 
                                        },
                                Font:{
                                    Size:10,
                                    Bold:"1",
                                    Color:"#000000",
                            },                           
                                    }
                                },
                            5:{style:{
                                Interior:{ 
                                    Color:"#95a5a6",
                                    Pattern:"Solid"
                                            },
                                Alignment:{
                                    Horizontal: 'Center', 
                                    Vertical: 'Center',
                                    WrapText: 1, 
                                },
                                Font:{
                                    Size:10,
                                    Bold:"1",
                                    Color:"#000000",
                            },                           
                                    }
                                },
                            6:{style:{
                                Interior:{ 
                                    Color:"#95a5a6",
                                    Pattern:"Solid"
                                            },
                                Alignment:{
                                    Horizontal: 'Center', 
                                    Vertical: 'Center',
                                    WrapText: 1, 
                                },
                                Font:{
                                    Size:10,
                                    Bold:"1",
                                    Color:"#000000",
                            },                           
                                    }
                                },
                            7:{style:{
                                Interior:{ 
                                    Color:"#95a5a6",
                                    Pattern:"Solid"
                                            },
                                Alignment:{
                                    Horizontal: 'Center', 
                                    Vertical: 'Center',
                                    WrapText: 1, 
                                },
                                Font:{
                                    Size:10,
                                    Bold:"1",
                                    Color:"#000000",
                            },                           
                                    }
                            }, 
                            8:{style:{
                                Interior:{ 
                                    Color:"#95a5a6",
                                    Pattern:"Solid"
                                            },
                                Alignment:{
                                    Horizontal: 'Center', 
                                    Vertical: 'Center',
                                    WrapText: 1, 
                                },
                                Font:{
                                    Size:10,
                                    Bold:"1",
                                    Color:"#000000",
                            },                           
                                    }
                                },                
                            }   
                  },
            };
            alasql.promise('SELECT * INTO XLSXML("Ventas_'+moment().format('DD-MM-YYYY')+'.xls",?) FROM ?',[mystyle,report])
            .then(function(data){
                console.log('Data saved');
            }).catch(function(err){
                console.log('Error:', err);
            });
          });
    }

}



// WEBPACK FOOTER //
// ./src/app/expenses/components/list-expenses/list-expenses.component.ts